// extracted by mini-css-extract-plugin
export default {"grid":"TrifectaField_grid__iXM7-","boxed":"TrifectaField_boxed__aQols"};